import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouterProps } from '../../utils/with-router-props'

import SHSForm from '../../utils/shs-form'
import InputElement from '../../utils/input'
import { callApi, callFileApi, fetchApiDataIfNeeded } from '../../../actions/api'
import { apiResourceEndpoint, buildRoutePath, routes } from '../../../constants/routes'

const mapStateToProps = (state) => {
    return {
        configs: state.configs.filter(config => config.field === 'QUESTION_TYPES')
    }
}

const AdminQuestionCreate = ({ dispatch, navigate, configs, adminQuestions }) => {
    const [typeId, setTypeId] = useState(null)
    // const [imagePreview, setImagePreview] = useState(null)

    useEffect(() => {
        dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('configs', 'LIST', null), { filter: ['field|QUESTION_TYPES'] }))
    }, [dispatch])

    const typeOptions = () => {
        if (!configs) {
            return null
        }
        return configs.map(config => {
            return ({ value: config.id, label: config.display })
        })
    }

    const submitFX = (formData, formId) => {
        if (typeId === 'EXAMPLE_PHOTO') {
            dispatch(callFileApi(apiResourceEndpoint('admin/questions', 'CREATE'), formData, formId))
        } else {
            dispatch(callApi(apiResourceEndpoint('admin/questions', 'CREATE'), formData, formId))
        }
    }

    const successFX = () => {
        navigate(buildRoutePath(routes.adminQuestionIndex.path))
    }

    const handleImagePreview = (id, value) => {
        const fileInput = document.getElementById(id)
        if (fileInput) {
            // const file = fileInput.files[0]
            // const imageUrl = URL.createObjectURL(file)
            // setImagePreview(imageUrl)
        }
    }

    return (
        <div className="admin-dashboard">
            <div className="header">
                <div className="container">
                    <div className="header-details">
                        <h1>Add a New Question</h1>
                    </div>
                </div>
            </div>
            <div className="content-wrapper">
                <div className="container">
                    <div className="content-box editable">
                        <SHSForm
                            extraClass="flex-form"
                            submitFX={submitFX}
                            successFX={successFX}
                            useFormData={typeId === 'EXAMPLE_PHOTO'}
                            showCancel={true}
                            cancelAction={() => navigate(buildRoutePath(routes.adminQuestionIndex.path))}>
                            <InputElement
                                type="text"
                                id="label"
                                label="Question Title"
                                placeholder="Date of Completion"
                                extraClass="flex-50"
                                required />
                            <InputElement
                                type="text"
                                id="instructions"
                                label="Instructions"
                                placeholder="Further instructions for the user"
                                extraClass="flex-50" />
                            <InputElement
                                type="valueSelect"
                                id="typeId"
                                label="Type"
                                placeholder="Select a type"
                                onChange={(id, value) => {
                                    const selectedOption = configs.find(c => c.id === parseInt(value, 10))
                                    setTypeId(selectedOption.value)
                                }}
                                options={typeOptions()}
                                extraClass="flex-50"
                                required />
                            {typeId === 'EXAMPLE_PHOTO' &&
                            <>
                                <InputElement
                                    accept="image/*"
                                    type="file"
                                    id="exampleImage"
                                    onChange={handleImagePreview} />
                                <InputElement
                                    type="text"
                                    id="exampleCaption"
                                    label="Describe the example photo"
                                    placeholder="Details about why this is a good example"/>
                                {/* {imagePreview &&
                                    <div className="example-photo image-wrapper">
                                        <img src={imagePreview} alt="preview" />
                                    </div>
                                } */}
                            </>
                            }
                            <InputElement
                                type="text"
                                id="options"
                                label="Options(not required)"
                                placeholder="Prompts or options for the user"
                                extraClass="flex-50" />
                            {typeId === 'TEXT' &&
                                <InputElement
                                    type="text"
                                    id="defaultValue"
                                    label="Default Value (not required)"
                                    placeholder="A default answer to the question"
                                    extraClass="flex-50" />
                            }
                        </SHSForm>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withRouterProps(connect(mapStateToProps)(AdminQuestionCreate))
